module.exports = __webpack_public_path__ + "img/seed_logo.b65f3e4b.png";